import { UiHints } from './types';

/**
 * Client-Side Presentation Configurations
 * 
 * Separates presentation concerns (HUD visibility, score display modes, visual indicators,
 * and game terminology) from server-authoritative gameplay rules.
 */

export const BW_UI_PRESENTATION: UiHints = {
  scoreDisplayMode: 'POINTS_7IO',
  scoreMode: 'TEAMS',
  badgeMode: 'BOOKS_WON',
  themeSymbol: '♠',
  showContractHud: true,
  showBooksToSetCounter: true,
  showBagsCounter: false,
  showDirectionIndicator: true,
  targetScore: 7,
  trickNoun: 'book',
  trickNounPlural: 'books',
  terminology: {
    trick: 'book',
    trickPlural: 'books',
    round: 'hand',
    contract: 'contract',
    kitty: 'kitty',
    declarer: 'winning bidder',
    set: 'set'
  }
};

export const SPADES_UI_PRESENTATION: UiHints = {
  scoreDisplayMode: 'POINTS_500',
  scoreMode: 'TEAMS',
  badgeMode: 'BOOKS_WON',
  themeSymbol: '♠',
  showContractHud: false,
  showBooksToSetCounter: false,
  showBagsCounter: true,
  showDirectionIndicator: false,
  targetScore: 500,
  trickNoun: 'trick',
  trickNounPlural: 'tricks',
  terminology: {
    trick: 'trick',
    trickPlural: 'tricks',
    round: 'hand',
    contract: 'bid',
    kitty: 'widow',
    declarer: 'high bidder',
    set: 'set'
  }
};

export const HEARTS_UI_PRESENTATION: UiHints = {
  scoreDisplayMode: 'POINTS_500',
  scoreMode: 'INDIVIDUAL',
  badgeMode: 'PENALTY_POINTS',
  themeSymbol: '♥',
  showContractHud: false,
  showBooksToSetCounter: false,
  showBagsCounter: false,
  showDirectionIndicator: false,
  targetScore: 100,
  trickNoun: 'trick',
  trickNounPlural: 'tricks',
  terminology: {
    trick: 'trick',
    trickPlural: 'tricks',
    round: 'hand',
    contract: 'points',
    kitty: 'widow',
    declarer: 'lead',
    set: 'points'
  }
};

export const GAME_UI_PRESENTATION: Record<string, UiHints> = {
  BID_WHIST: BW_UI_PRESENTATION,
  SEVEN_IN_OUT: BW_UI_PRESENTATION,
  BEST_OF_3: BW_UI_PRESENTATION,
  SPADES: SPADES_UI_PRESENTATION,
  '500_PTS': SPADES_UI_PRESENTATION,
  '250_PTS': SPADES_UI_PRESENTATION,
  '300_PTS': SPADES_UI_PRESENTATION,
  HEARTS: HEARTS_UI_PRESENTATION,
  '100_PTS': HEARTS_UI_PRESENTATION,
  '50_PTS': HEARTS_UI_PRESENTATION
};
